
/* eslint-disable no-unused-vars */
import { defineComponent, ref, computed, onMounted } from "vue";
import axios from "axios";
import { store } from "@/store";
import { setCanvasJson, setCanvasJPEG } from "@/canvas-api/ConvertCanvas";
import CloseSVG from "@/components/CloseSVG.vue";
import useHandleModal from "@/composables/useHandleModal";
import { getEditorUrlParam } from "@/composables/useParseURL";
import { CurrentLabel } from "@/types";

export default defineComponent({
  name: "SaveTemplateWrap",
  components: {
    CloseSVG,
  },
  setup() {
    const { showModal, handleModal, bounceTransition, fadeTransition } = useHandleModal();

    const editorParams = computed(() => store.getters.editorParams);
    const currentLabel = computed<CurrentLabel>(() => store.getters.currentLabel);
    const template = computed(() => store.getters.templateAndLabel.template);

    const isRotated = computed<boolean>(() =>
      store.getters.canvasOrientation === "rotated" ? true : false
    );
    const getDefaultOrientation = computed<string>(() =>
      store.getters.currentLabel.width >= store.getters.currentLabel.height
        ? "landscape"
        : "portrait"
    );
    const currentOrientation = computed<string>(() =>
      isRotated.value
        ? getDefaultOrientation.value === "landscape"
          ? "portrait"
          : "landscape"
        : getDefaultOrientation.value
    );

    const title = ref("");
    const templateName = ref("");
    onMounted(() => {
      templateName.value = template.value ? template.value.title : "Blank";
      //Trigger rerender on mount
      title.value = "Save Template";
    });

    const loading = ref(false);
    const handleSaveTemplate = async () => {
      loading.value = true;

      const canvasAsJSON = await setCanvasJson();
      const canvasAsJPEG = setCanvasJPEG();

      if (canvasAsJSON && canvasAsJPEG) {
        try {
          // prettier-ignore
          const data = {
            active: 0,
            admin_id: 1,
						title: templateName.value,
						width: currentLabel.value.width,
						height: currentLabel.value.shape_id === 10 || currentLabel.value.shape_id === 3 ? currentLabel.value.width : currentLabel.value.height,
						shape_id: currentLabel.value.shape_id,
						label_id: currentLabel.value.label_id,
						editor: "full",
						editorvue: "1",
						blank_editor: "0",
						product_id: editorParams.value.product_id,
						orientation: currentOrientation.value,
						json: canvasAsJSON,
            preview: canvasAsJPEG,
            template_id: getEditorUrlParam("template_id").length ? getEditorUrlParam("template_id") : undefined
					};

          await axios.post(`${process.env.VUE_APP_API_URL}/editor/templates/ajax.php`, data);

          handleModal();

          loading.value = false;
        } catch (e) {
          console.log(e);

          loading.value = false;
        }
      }
    };

    return {
      showModal,
      handleModal,
      bounceTransition,
      fadeTransition,
      title,
      templateName,
      loading,
      handleSaveTemplate,
    };
  },
});
